import { render } from "./Jishizi2024.vue?vue&type=template&id=6bc73d46&scoped=true"
import script from "./Jishizi2024.vue?vue&type=script&lang=js"
export * from "./Jishizi2024.vue?vue&type=script&lang=js"

import "./Jishizi2024.vue?vue&type=style&index=0&id=6bc73d46&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc73d46"]])

export default __exports__